import { FunctionComponent } from "react";
import { StepType } from "types";
import Header from "./Header";
import Footer from "./Footer";

const Layout: FunctionComponent<StepType> = (props) => {
  return (
    <>
      <Header step={props.step} urlCode={props.urlCode} />
      <main role="main" className="main">
        {props.children}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
